import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d0243458"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'BilibiliMinigamePay'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList2 = ref([]);
    const bilibiliFormRef = ref(null);
    const bilibiliForm = reactive({
      divide: '',
      pkg: '',
      appId: '',
      appSecret: '',
      accessKey: '',
      accessToken: ''
    });
    const validateForm = () => {
      var _bilibiliFormRef$valu;
      (_bilibiliFormRef$valu = bilibiliFormRef.value) === null || _bilibiliFormRef$valu === void 0 || _bilibiliFormRef$valu.validate().then(() => {
        emit('submitForm', bilibiliForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      var _n$pkg, _n$appId, _n$accessToken, _ref, _n$accessKey, _n$rateList, _n$divide;
      if (!n) return;
      bilibiliForm.pkg = (_n$pkg = n.pkg) !== null && _n$pkg !== void 0 ? _n$pkg : '';
      bilibiliForm.id = n.id;
      bilibiliForm.appId = (_n$appId = n.appId) !== null && _n$appId !== void 0 ? _n$appId : '';
      bilibiliForm.appSecret = n.appSecret;
      bilibiliForm.accessToken = (_n$accessToken = n.accessToken) !== null && _n$accessToken !== void 0 ? _n$accessToken : '';
      bilibiliForm.accessKey = (_ref = (_n$accessKey = n.accessKey) !== null && _n$accessKey !== void 0 ? _n$accessKey : n.access_key) !== null && _ref !== void 0 ? _ref : '';
      divideList2.value = (_n$rateList = n.rateList) !== null && _n$rateList !== void 0 ? _n$rateList : [];
      bilibiliForm.divide = (_n$divide = n.divide) !== null && _n$divide !== void 0 ? _n$divide : '';
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: bilibiliForm,
        ref_key: "bilibiliFormRef",
        ref: bilibiliFormRef,
        rules: __props.rules,
        name: "bilibili-minigame-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: bilibiliForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => bilibiliForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "APPID: "
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: bilibiliForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => bilibiliForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "accessKey",
          label: "access_key："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: bilibiliForm.accessKey,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => bilibiliForm.accessKey = $event),
            valueModifiers: {
              trim: true
            },
            placeholder: "请输入 access_key",
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "accessToken",
          label: "access_token："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: bilibiliForm.accessToken,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => bilibiliForm.accessToken = $event),
            valueModifiers: {
              trim: true
            },
            placeholder: "请输入 access_token",
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: bilibiliForm.divide,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => bilibiliForm.divide = $event),
            options: divideList2.value,
            placeholder: "请选择分成比例"
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});